import { create } from 'zustand';
import { clientFavoritesControllerApi } from '@api/api-config.ts';
import { ProductTileResponse, SupplierDeliveryWindow } from '@api/generated/search-service';
import { useOrgPortal } from '@hooks/useOrgPortal.ts';
import i18next from 'i18next';
import { applyProductTileUpdateToList, mergeSupplierDelivery, subscribeProductTileUpdate } from '@features/product-detail/productTileUpdates.ts';

interface FavoriteListStore {
  loading: boolean;
  error: string | null;

  favoriteItems: ProductTileResponse[];
  supplierDelivery: SupplierDeliveryWindow[] | null;
  loadFavoriteList: (query?: string) => Promise<void>;
}

// Pořadí posledního požadavku — odpověď staršího (pomalejšího) požadavku nesmí přepsat novější.
let lastRequestId = 0;

export const useFavoriteListStore = create<FavoriteListStore>(set => ({
  loading: false,
  error: null,
  favoriteItems: [],
  supplierDelivery: null,

  loadFavoriteList: async (query?: string) => {
    const requestId = ++lastRequestId;
    try {
      set({ loading: true });
      const { orgId: organizationId, portalId } = useOrgPortal.getState();

      const res = await clientFavoritesControllerApi.getFavoritesList({ organizationId, portalId, query });
      if (requestId !== lastRequestId) return;
      set({ loading: false, favoriteItems: res.data.products, supplierDelivery: res.data.supplierDelivery });
    } catch (error) {
      if (requestId !== lastRequestId) return;
      set({ error: error instanceof Error ? error.message : i18next.t('client:favorites.loadError'), loading: false });
    }
  },
}));

subscribeProductTileUpdate(update =>
  useFavoriteListStore.setState(state => ({
    favoriteItems: applyProductTileUpdateToList(state.favoriteItems, update),
    supplierDelivery: mergeSupplierDelivery(state.supplierDelivery, update),
  })),
);
